import React from 'react';
import {Field} from 'formik';
import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Typography
} from "@mui/material";
import Constants from "../../../../utils/constants";
import Grid from "@mui/material/Grid2";


function ProblemLaveuseDataField({...props}) {
    const {values, errors, handleChange, handleBlur} = props;


    return (
        <Grid container spacing={1} className={"sectionContainer"}>
            <Grid size={12}>
                <Typography variant={"h5"} className={"sectionHeader"}>Informations</Typography>
            </Grid>

            {/*LIBELLE FIELD*/}
            <Grid item container alignItems={"center"}>
                <Grid size={3}>
                    Libellé <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        value={values.libelle}>
                        {({field, form}) => (
                            <TextField
                                error={
                                    Boolean(form.errors.libelle && form.touched.libelle)
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.libelle}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="libelle"
                                label="Libellé"
                                autoFocus
                                helperText={
                                    form.errors.libelle &&
                                    form.touched.libelle &&
                                    String(form.errors.libelle)
                                }/>
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/*CATEGORY FIELD*/}
            <Grid item container alignItems={"center"} className={"mt-2"}>
                <Grid size={3}>
                    Catégorie <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        name="category"
                        value={values.category}>
                        {({field, form}) => (
                            <FormControl fullWidth error={Boolean(errors.category)}>
                                <InputLabel id="label-exploitant">Sélectionner la catégorie :</InputLabel>
                                <Select
                                    labelId="label-exploitant"
                                    label="Sélectionner la catégorie :"
                                    variant="outlined"
                                    name="category"
                                    value={values.category}
                                    onChange={handleChange}
                                >
                                    {Constants.LAVEUSE_PROBLEMS_CATEGORIES && Constants.LAVEUSE_PROBLEMS_CATEGORIES.map((ct) => {
                                        return (
                                            <MenuItem key={ct.code} value={ct.code}>
                                                {ct.libelle}
                                            </MenuItem>
                                        )
                                    })}
                                </Select>
                                {form.errors.category &&
                                    form.touched.category &&
                                    <FormHelperText error={true}>{form.errors.category}</FormHelperText>}
                            </FormControl>
                        )
                        }
                    </Field>
                </Grid>
            </Grid>

            {/*IMPORTANCE FIELD*/}
            <Grid item container alignItems={"center"} className={"mt-2"}>
                <Grid size={3}>
                    Importance (sévérité) <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        value={values.importance}>
                        {({field, form}) => (
                            <ToggleButtonGroup
                                color={"primary"}
                                exclusive
                                size={"medium"}
                                name="importance"
                                value={values.importance}
                                onChange={(event, newValue) => {
                                    if (newValue !== null) {
                                        form.setFieldValue('importance', newValue);
                                    }
                                }}
                                aria-label={"Importance"}
                            >
                                {Constants.PROBLEMS_LAVEUSE_IMPORTANCE && Constants.PROBLEMS_LAVEUSE_IMPORTANCE.map((importance, i) => {
                                    const isSelected = values.importance === importance.code;

                                    const buttonStyles = {
                                        backgroundColor: isSelected ? importance.color : 'transparent',
                                        color: isSelected ? 'white' : 'black'
                                    }

                                    return (
                                        <ToggleButton key={i} value={importance.code} style={buttonStyles}>
                                            {importance.libelle}
                                        </ToggleButton>
                                    )
                                })}
                                {form.errors.importance &&
                                    form.touched.importance &&
                                    <FormHelperText error={true}>{form.errors.importance}</FormHelperText>}
                            </ToggleButtonGroup>

                        )}
                    </Field>

                </Grid>
            </Grid>
        </Grid>
    );
}

export default ProblemLaveuseDataField;
